import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './global.css'
import App from './App.vue'
import router from './router'
import permissionState, { hasPermission } from './store/permission'

window.addEventListener('unhandledrejection', event => {
  if (event.reason === 'cancel' || event.reason === 'close') {
    event.preventDefault()
  }
})

Vue.use(ElementUI)

const originConfirm = Vue.prototype.$confirm
Vue.prototype.$confirm = function (...args) {
  return originConfirm.apply(this, args).catch(reason => {
    if (reason === 'cancel' || reason === 'close') {
      return new Promise(() => {})
    }
    return Promise.reject(reason)
  })
}

Vue.prototype.$hasPermission = hasPermission
Vue.prototype.$permissionState = permissionState
new Vue({ router, render: h => h(App) }).$mount('#app')
